module.exports = __webpack_public_path__ + "static/CreateMySQL-eda1daefb05bc9664e8ed310b6c55498.png";